<section class="new_login_section">
  <div class="logo_div text-center">
    <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Header/logo.png" class="logo">
  </div>
  <div class="login_flex_box">
    <div class="left_section">
      <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/login_left_img.svg"
        class="login_left_img">
      <h1>The Godfather of Accountants<br /> Welcomes you!</h1>
    </div>
    <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/line.svg" class="line_img">
    <div class="right_section">
      <p style="font-family: var(--san_francisco_reg)">Welcome to the Miles Family! Let's get started!</p>
      <br>
      <p style="color:  #06345B" class="blink">Bookmark this URL for future logins!</p>
      <br>
      <!-- <p style="font-family: var(--san_francisco_reg)" class="mb-1">Note that this LMS also contains beta version of features related to 2024 that will be fully functional from <span class="customBold">October 3rd</span></p> -->
      <!-- <br> -->
      <!-- <div class="text-center"> -->
      <span class="text-center" style="color: red;" *ngIf="errorMessage"><br>{{errorMessage}}</span>
      <!-- </div> -->
      <form [formGroup]="loginForm">
        <div style="position: relative;">
          <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/mailIcon.svg"
            class="left_icon">
          <input type="text" class="form_control" placeholder="Username" formControlName="registration_id">
        </div>
        <div style="position: relative;">
          <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/passwordIcon.svg"
            class="left_icon">
          <input type="{{showHidePass === 'fa-eye-slash'?'password':'text'}}" class="form_control"
            placeholder="Password" formControlName="password">
          <span class="toggle_icon">
            <i class=" fas {{showHidePass}} active" style="font-size: 1rem; color: rgb(156 163 175);"
              (click)="showHidePassword()"></i>
          </span>
        </div>
        <!-- <button type="button" class="blue_btn">Sign in</button> -->
        <button *ngIf="is_clicked==false" [disabled]="!loginForm.valid" mdbWavesEffect (click)="onSubmit()"
          class="blue_btn">Sign In</button>
        <button *ngIf="is_clicked==true" [disabled] class="blue_btn">Sign In <i class="fa fa-spinner fa-spin"></i>
        </button>
      </form>
      <a routerLink="unable-to-login" class="forgot_pwd" style="color:  #06345B">Forgot Password? </a>
    </div>
  </div>
</section>